<template>
    <Page class="ProjectConfirmation">
        <img class="Logo" :class="{ 'Logo--right': logoPosition === 'right' }" :src="logoSrc">
        <div class="ProposalInfo">
            <span class="Proposal-Info-Number">{{ projectType }} Nr. {{ projectNumber }}</span>
            <span class="Proposal-Info-Date">vom {{ projectDate }}</span>
        </div>
        <h2 class="ProjectConfirmation-Title">Rechnungslegung</h2>
        <article class="" ref="projectConfirmation" />
        <div class="Signature">Datum, Unterschrift, Stempel</div>
        <CompanyAddress :company="company" />
    </Page>
</template>
<script>
import Page from './Page.vue';
import CompanyAddress from './CompanyAddress.vue';

export default {
    name: 'CoverPage',
    components: {
        Page,
        CompanyAddress
    },
    props: {
        company: {
            type: Object,
            default: () => null
        },
        logoPosition: {
            type: String,
            default: 'left'
        },
        projectConfirmation: {
            type: String,
            default() {
                return null
            }
        },
        projectDate: {
            type: String,
            default() {
                return ""
            }
        },
        projectType: {
            type: String,
            default() {
                return ""
            }
        },
        projectNumber: {
            type: String,
            default() {
                return ""
            }
        }
    },

    data() {
        return {}
    },
    created() {

    },
    watch: {
        projectConfirmation: function (val) {
            this.$refs.projectConfirmation.innerHTML = val;
        }
    },
    computed: {
        logoSrc() {
            if (!this.company || this.company.isMain) return require('../../assets/logo.svg');
            const name = this.company.LogoName || (this.company.InternalName ? this.company.InternalName.toLowerCase() + '.svg' : '');
            return name
                ? `/static/${name}`
                : require('../../assets/logo.svg');
        }
    },
    methods: {},
    mounted() {
        this.$refs.projectConfirmation.innerHTML = this.projectConfirmation;
    }
}
</script>

<style lang="scss">
// h1,
// h2,
// p {
//     display: block;
// }

.ProjectConfirmation {
    &-Title {
        padding-top: 15px;
        font-weight: 600;
        font-size: 10pt;
    }

    h1,
    h2 {
        margin: 0;
    }

    .ProposalInfo {
        padding-bottom: 25px;
    }

    article {
        padding-top: 0;

        p,
        ul,
        ol {
            &:first-child {
                margin-top: .4em;
            }
        }

        p {
            padding: 0;
        }
    }

    .Signature {
        position: relative;
        padding-top: 100px;
        font-size: 8.5pt;

        &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 1.5em;
            height: 1px;
            width: 320px;
            background-color: color(text-negative);
        }
    }
}
</style>



// WEBPACK FOOTER //
// ConfirmationPage.vue?07583d16